import React, { Component } from "react";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import classnames from "classnames";
import moment from "moment";
import SendNotification from "../add";
import ViewReplies from "../view";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { BreadCrumb } from "../../../components/breadcrumb";
import { Loader } from "../../../components/loader";
import {
  getNotifications,
  getReplies,
  setReplyCustomerInfo,
  resendNotification,
  stopSendingProcess,
  markAsRead,
} from "../../../actions/notificationManager";

const $ = window.$;
const { SearchBar } = Search;
const Status = {
  all: "All",
  none: "None",
  waiting: "Waiting",
  inProgress: "In-Progress",
  sent: "Sent",
  failed: "Failed",
  unsubscribed: "Unsubscribed",
  containReplies: "Contains-Replies"
};

class MessagingCampaignList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
      waitingNotifications: [],
      inProgressNotifications: [],
      sentNotifications: [],
      failedNotifications: [],
      unsubscribedNotifications: [],
      containsRepliesNotifications: [],
      selectedItem: null,
      isLoading: true,
      selectedCustomerToExclude: null,
      isWaitingMessagesAvailable: false,
      selectedTab: "All",
    };
  }

  componentDidMount() {
    this.props.getNotifications();
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.notifications !== nextProps.notifications) {
      let isWaitingAvailable = false;

      // Categorize notifications by status
      let waitingNotifications = nextProps.notifications.filter((notification) => notification.status === Status.waiting);
      let inProgressNotifications = nextProps.notifications.filter((notification) => notification.status === Status.inProgress);
      let sentNotifications = nextProps.notifications.filter((notification) => notification.status === Status.sent);
      let failedNotifications = nextProps.notifications.filter((notification) => notification.status === Status.failed);
      let unsubscribedNotifications = nextProps.notifications.filter((notification) => notification.status === Status.unsubscribed);
      let containsRepliesNotifications = nextProps.notifications.filter(
        (notification) => notification.read > 0 || notification.delivered > 0
      );

      this.setState({
        notifications: nextProps.notifications,
        waitingNotifications: waitingNotifications,
        inProgressNotifications: inProgressNotifications,
        sentNotifications: sentNotifications,
        failedNotifications: failedNotifications,
        unsubscribedNotifications: unsubscribedNotifications,
        containsRepliesNotifications: containsRepliesNotifications,
        isLoading : false,
      });

      if (nextProps.notifications.length > 0) {
        for (let notification of nextProps.notifications) {
          if (notification.status === Status.waiting) {
            isWaitingAvailable = true;
            break;
          } else {
            isWaitingAvailable = false;
          }
        }
        this.setState({ isWaitingMessagesAvailable: isWaitingAvailable });
      }
    }

    if(this.props.notificationsError !== nextProps.notificationsError){
      NotificationManager.error("An error occurred while loading the messages");
      this.setState({ isLoading : false,});
    }

    if (this.props.resend !== nextProps.resend) {
      this.props.getNotifications();
    }

    if (this.props.stopProcess !== nextProps.stopProcess) {
      if (nextProps.stopProcess && nextProps.stopProcess.message) {
        NotificationManager.success(nextProps.stopProcess.message);
      }
      this.props.getNotifications();
    }

    if (this.props.markedRead !== nextProps.markedRead) {
      this.props.getNotifications();
    }
  };

  closeModal = () => {
    this.setState({ selectedCustomerToExclude: null });
    $("#exclude-customer-modal").modal("toggle");
  };

  items = [{ title: "Messaging Campaigns", to: "/messaging-campaigns" }];

  buttonFormatter = (cell, row) => {
    return (
      <div className="reply">
        <div
          className="btn-container"
          data-target="#view-replies"
          data-toggle="modal"
          onClick={(e) => this.fetchRelies(e, row)}
        >
          <div className="reply-view-btn">
            <i className="fa fa-comments"></i>
            {cell > 0 ? <span className="reply-badge">{cell}</span> : null}
          </div>
        </div>
      </div>
    );
  };

  tableHeaderColumnData = [
    {
      dataField: "delivered",
      text: "",
      formatter: this.buttonFormatter.bind(this),
      headerClasses: "notification-actions",
    },
    {
      dataField: "read",
      text: "Reply Count",
      formatter: (cell, row) => <span className="read-badge">{cell}</span>,
      headerClasses: "notification-actions",
    },
    {
      dataField: "Customer.firstname",
      text: "First Name",
      formatter: (cell, row) => <span>{row.Customer.firstname}</span>,
      headerClasses: "notification-col",
    },
    {
      dataField: "Customer.lastname",
      text: "Last Name",
      formatter: (cell, row) => <span>{row.Customer.lastname}</span>,
      headerClasses: "notification-col",
    },
    {
      dataField: "Customer.phone_primary",
      text: "Customer Phone Number (to)",
      formatter: (cell, row) => (
        <a href={`tel:${row.Customer.phone_primary}`} className="hyperlink-phone-number">
          {row.Customer.phone_primary}
        </a>
      ),
      headerClasses: "notification-col",
    },
    {
      dataField: "updatedAt",
      text: "Sent At",
      formatter: (cell) => (
        <div>
          <span>{moment(cell).format("lll")}</span>
        </div>
      ),
      headerClasses: "notification-col",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        $(function () {
          $(".message-popover").popover({
            container: "body",
          });
        });
        return (
          <div>
            {cell === Status.none ? (
              <span className="m-badge m-badge--secondary mx-auto my-0 px-2">
                <strong>None</strong>
              </span>
            ) : null}
            {cell === Status.waiting ? (
              <span className="m-badge m-badge--warning mx-auto my-0 px-2 status">
                <strong
                  className="popover-dismiss message-popover"
                  data-toggle="popover"
                  data-trigger="focus"
                  tabIndex="-1"
                  title="Message"
                  data-content={row.NotificationMessage && row.NotificationMessage.message}
                >
                  Waiting
                </strong>
              </span>
            ) : null}
            {cell === Status.inProgress ? (
              <span className="m-badge m-badge--info mx-auto my-0 px-2 status">
                <strong
                  className="popover-dismiss message-popover"
                  data-toggle="popover"
                  data-trigger="focus"
                  tabIndex="-1"
                  title="Message"
                  data-content={row.NotificationMessage && row.NotificationMessage.message}
                >
                  In-Progress
                </strong>
              </span>
            ) : null}
            {cell === Status.sent ? (
              <span className="m-badge m-badge--success mx-auto my-0 px-2 status">
                <strong
                  className="popover-dismiss message-popover"
                  data-toggle="popover"
                  data-trigger="focus"
                  tabIndex="-1"
                  title="Message"
                  data-content={row.NotificationMessage && row.NotificationMessage.message}
                >
                  Sent
                </strong>
              </span>
            ) : null}
            {cell === Status.failed ? (
              <span className="m-badge m-badge--danger mx-auto my-0 px-2 status">
                <strong
                  className="popover-dismiss message-popover"
                  data-toggle="popover"
                  data-trigger="focus"
                  tabIndex="-1"
                  title="Message"
                  data-content={row.NotificationMessage && row.NotificationMessage.message}
                >
                  Failed
                </strong>
              </span>
            ) : null}
            {cell === Status.unsubscribed ? (
              <span className="m-badge bg-dark text-light mx-auto my-0 px-2">
                <strong>Unsubscribed</strong>
              </span>
            ) : null}
          </div>
        );
      },
      headerClasses: "notification-col-status",
    },
    {
      dataField: "information",
      text: "More Information",
      headerClasses: "notification-info-col",
    },
  ];

  fetchRelies = (e, row) => {
    if (row && row.Customer && row.Customer.id) {
      const info = {
        customer: row.Customer,
        notificationStatus: row.status,
      };
      this.props.markAsRead(row.Customer.id);
      this.props.getReplies(row.Customer.id);
      this.props.setReplyCustomerInfo(info);
    }
  };

  setExcludeCustomer = (e, row) => {
    if (row && row.Customer) {
      this.setState({ selectedCustomerToExclude: row.Customer.id });
    }
  };

  fetchNotificationInfo = (e) => {
    NotificationManager.success("Messaging campaign queue data refreshed successfully");
    this.props.getNotifications();
  };

  resendNotification = (e, notificationId) => {
    e.preventDefault();
    this.props.resendNotification(notificationId);
  };

  stopProcess = (e) => {
    this.props.stopSendingProcess();
  };

  render() {
    const {
      notifications,
      waitingNotifications,
      inProgressNotifications,
      sentNotifications,
      failedNotifications,
      unsubscribedNotifications,
      containsRepliesNotifications,
      selectedItem,
      isWaitingMessagesAvailable,
      selectedTab,
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                {/* Start: Page Header */}
                <div className="m-portlet__head notification-action-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Messaging Campaigns
                        <small>List of all messaging campaigns</small>
                      </h3>
                    </div>
                  </div>
                  <div className="notification-manager-button-container">
                    {isWaitingMessagesAvailable ? (
                      <div className="m-portlet__head-tools notification-refresh-btn">
                        <button
                          className="m-nav__link btn btn-warning m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                          onClick={this.stopProcess}
                        >
                          <span>
                            <i className="fa fa-stop"></i>
                            <span>Stop</span>
                          </span>
                        </button>
                      </div>
                    ) : null}
                    <div className="m-portlet__head-tools notification-refresh-btn">
                      <div
                        className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                        onClick={this.fetchNotificationInfo}
                      >
                        <span>
                          <i className="fas fa-sync"></i>
                          <span>Refresh</span>
                        </span>
                      </div>
                    </div>
                    <div className="m-portlet__head-tools notification-send-btn">
                      <div
                        className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                        data-toggle="modal"
                        data-target="#send-notification-modal"
                      >
                        <span>
                          <i className="fas fa-paper-plane"></i>
                          <span>Send Notification</span>
                        </span>
                      </div>{" "}
                    </div>
                  </div>
                </div>
                {/* End: Page Header */}

                {/* Start: Page Body */}
                <div className="m-portlet__body">
                  <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "All",
                        })}
                        onClick={() => this.setState({ selectedTab: "All" })}
                      >
                        All
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "Waiting",
                        })}
                        onClick={() => this.setState({ selectedTab: "Waiting" })}
                      >
                        Waiting
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "In-Progress",
                        })}
                        onClick={() => this.setState({ selectedTab: "In-Progress" })}
                      >
                        In Progress
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "Sent",
                        })}
                        onClick={() => this.setState({ selectedTab: "Sent" })}
                      >
                        Sent
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "Failed",
                        })}
                        onClick={() => this.setState({ selectedTab: "Failed" })}
                      >
                        Failed
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "Unsubscribed",
                        })}
                        onClick={() => this.setState({ selectedTab: "Unsubscribed" })}
                      >
                        Unsubscribed
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "Contains-Replies",
                        })}
                        onClick={() => this.setState({ selectedTab: "Contains-Replies" })}
                      >
                        Contains Replies
                      </button>
                    </li>
                  </ul>
              { !this.state.isLoading ?
                <ToolkitProvider
                    keyField="id"
                    data={
                      selectedTab === Status.all
                        ? notifications
                        : selectedTab === Status.waiting
                        ? waitingNotifications
                        : selectedTab === Status.inProgress
                        ? inProgressNotifications
                        : selectedTab === Status.sent
                        ? sentNotifications
                        : selectedTab === Status.failed
                        ? failedNotifications
                        : selectedTab === Status.unsubscribed
                        ? unsubscribedNotifications
                        : selectedTab === Status.containReplies
                        ? containsRepliesNotifications
                        : {}
                    }
                    columns={this.tableHeaderColumnData}
                    search
                    filter={filterFactory()}
                  >
                    {(props) => (
                      <div>
                        <div className="px-0 mb-4 search-bar">
                          <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                            <i className="fas fa-search mt-1"></i>
                            <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                        <div className="mb-2">
                          <small className="small-text">
                            *If you experience any difficulty in viewing the messaging campaigns, please make sure your
                            cache is cleared and completed a hard refresh. IOS users might have to use a private window.
                          </small>
                        </div>
                        <BootstrapTable classes="petTable" {...props.baseProps} pagination={paginationFactory()} />
                      </div>
                    )}                    
                  </ToolkitProvider>:
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  }
                </div>
                {/* End: Page Body */}
              </div>
            </div>
          </div>
          <SendNotification />
          <ViewReplies selectedItem={selectedItem} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  notifications: state.notificationManagerReducer.notifications,
  resend: state.notificationManagerReducer.resendNotification,
  stopProcess: state.notificationManagerReducer.stopSending,
  markedRead: state.notificationManagerReducer.markRead,
  notificationsError : state.notificationManagerReducer.notificationsError,
});

const mapDispatchToProps = (dispatch) => ({
  getNotifications: () => {
    dispatch(getNotifications());
  },
  getReplies: (id) => {
    dispatch(getReplies(id));
  },
  setReplyCustomerInfo: (data) => {
    dispatch(setReplyCustomerInfo(data));
  },
  resendNotification: (id) => {
    dispatch(resendNotification(id));
  },
  stopSendingProcess: () => {
    dispatch(stopSendingProcess());
  },
  markAsRead: (id) => {
    dispatch(markAsRead(id));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessagingCampaignList));
